export const TOUR_PARTNER_DATA_API_SUCCESS = "TOUR_PARTNER_DATA_API_SUCCESS";
export const TOUR_PARTNER_DATA_API_ERROR = "TOUR_PARTNER_DATA_API_ERROR";
export const TOUR_PARTNER_DATA_API_START = "TOUR_PARTNER_DATA_API_START";